/* eslint jsx-a11y/no-static-element-interactions:0 */
import PropTypes from 'prop-types';

import React from 'react';
import { connect } from 'react-redux';
import Audio from '../components/Audio';
import actions from '../state/actions';
import {
  HIDE_NOTIFICATION,
} from '../state/types';
import { localize } from '../i18n';

const getPlatformSounds = () => {
  const SOUNDS = {
    notification: {
      src: '/static/sounds/Whisper.mp3',
      type: 'audio/mpeg',
    },
  };

  return SOUNDS;
};

const SOUNDS = getPlatformSounds();

const Notify = function Notify(props) {
  const {
    notify: {
      sound,
      message,
      show,
      location,
      action,
      actionPayload,
      showClose,
      type,
    },
    dispatchAction,
  } = props;
  let notifyEle = null;
  let audio = null;

  if (show === true) {
    if (sound !== null) {
      const soundInfo = SOUNDS[sound];
      audio = (
        <Audio source={soundInfo.src} type={soundInfo.type} />
      );
    }

    const localizationParameters = actionPayload.args && actionPayload.args[3];
    const localizedMessage = props.t(message, localizationParameters);

    notifyEle = (
      <div className={`Notify uk-notify uk-notify-${location}`}>
        <div
          className={`uk-notify-message ${(type !== null) ? `uk-notify-message-${type}` : ''}`}
          role="button"
          onClick={(evt) => {
            evt.preventDefault();
            if (action) {
              dispatchAction(action, actionPayload);
            }
          }}
        >
          <a
            className="uk-close"
            style={{ display: (showClose === true) ? 'block' : 'none' }}
            onClick={(evt) => {
              evt.preventDefault();
              evt.stopPropagation();
              dispatchAction(HIDE_NOTIFICATION);
            }}
          >
            <span>{props.t('Close')}</span>
          </a>
          <div>
            {localizedMessage}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      {audio}
      <div>
        {notifyEle}
      </div>
    </div>
  );
};

Notify.propTypes = {
  notify: PropTypes.shape({
    sound: PropTypes.oneOf([
      'notification',
    ]),
    type: PropTypes.oneOf([
      'info',
      'primary',
      'danger',
      'success',
      'warning',
    ]),
    location: PropTypes.oneOf([
      'top-center',
      'top-left',
      'top-right',
      'bottom-center',
      'bottom-left',
      'bottom-right',
    ]),
    action: PropTypes.string,
    show: PropTypes.bool,
    // eslint-disable-next-line
    actionPayload: PropTypes.object,
    message: PropTypes.string,
    showClose: PropTypes.bool,
  }),
  dispatchAction: PropTypes.func,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const notify = state.notify;
  return {
    notify,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatchAction(action, actionPayload) {
    dispatch(actions.notifyAction(action, actionPayload));
  },
});

export default localize(connect(mapStateToProps, mapDispatchToProps)(Notify));



// WEBPACK FOOTER //
// ./src/containers/Notify.js